import {appName} from '../settings/constants'
import {createSelector} from 'reselect'
import {Record} from 'immutable'
import RestService from '../helpers/RestService'
import {arrayToMap} from '../helpers/common'
import { SubmissionError } from 'redux-form'
import {ajaxUrls} from '../settings/routes'


/**
 * Constants
 * */

export const moduleName = 'support'
const prefix = `${appName}/${moduleName}`

export const INIT_UPLOAD_DIALOGS_START = `${prefix}/INIT_UPLOAD_DIALOGS_START`
export const INIT_UPLOAD_DIALOGS_SUCCESS = `${prefix}/INIT_UPLOAD_DIALOGS_SUCCESS`
export const INIT_UPLOAD_DIALOGS_FAIL = `${prefix}/INIT_UPLOAD_DIALOGS_FAIL`

export const SET_DIALOGS = `${prefix}/SET_DIALOGS`
export const SET_CURRENT_NAME = `${prefix}/SET_CURRENT_NAME`


/**
 * Reducer
 * */

export const dialogRecord = Record({
    id : null,
    name : "",
    question : "",
    answer : "",
    created_at : null,
    updated_at : null,
})

export const chatRecord = Record({
    dialogs : arrayToMap([], dialogRecord, 'name'),
    initLoaded : false,
    initLoading : false,
    addDialogPending : false,
    currentName : "",
})

export const ReducerRecord = Record({
    chat : new chatRecord(),
})

const defaultState = new ReducerRecord()

export default function reducer(state = defaultState, action) {
    const {type, payload} = action

    switch (type) {
        case INIT_UPLOAD_DIALOGS_START : {
            return state.setIn(['chat', 'initLoading'], true)
            break
        }
        case INIT_UPLOAD_DIALOGS_SUCCESS: {
            let {dialogs} = payload
            return state.setIn(['chat', 'dialogs'], arrayToMap(dialogs, dialogRecord, 'id'))
                        .setIn(['chat', 'initLoading'], false)
                        .setIn(['chat', 'initLoaded'], true)
            break
        }
        case INIT_UPLOAD_DIALOGS_FAIL : {
            return state.setIn(['chat', 'initLoading'], false)
                        .setIn(['chat', 'initLoaded'], false)
        }
        case SET_DIALOGS : {
            let {dialogs} = payload
            return state.updateIn(['chat', 'dialogs'], currDialogs => currDialogs.merge(arrayToMap(dialogs, dialogRecord, 'id')))
            break
        }
        case SET_CURRENT_NAME : {
            let {name} = payload
            return state.setIn(['chat', 'currentName'], name)
            break
        }
        default : {
            return state
            break
        }
    }
}


/**
 * Selectors
 * */

export const stateSelector = state => state[moduleName]
export const chatSelector = createSelector(stateSelector, state => state.chat)
export const supportLoadStateSelector = createSelector(chatSelector, chat => ({initLoaded : chat.initLoaded, initLoading : chat.initLoading}))
export const dialogsMapSelector = createSelector(chatSelector, state => state.dialogs)
export const dialogsSelector = createSelector(dialogsMapSelector, dialogsMap => dialogsMap.valueSeq().toArray())

const _getDialogName = (_, name) => name
export const dialogsByNameSelector = createSelector(dialogsSelector, _getDialogName, (dialogs, name) => dialogs.filter(dialog => dialog.name === name))
export const currentDialogNameSelector = createSelector(chatSelector, state => state.currentName)
export const currentDialogsSelector = createSelector(dialogsSelector, currentDialogNameSelector, (dialogs, currentName) => dialogs.filter(dialog => dialog.name == currentName))

/**
 * Action Creators
 * */

export const setDialogs = (params) => {
    let {dialogs = []} = params
    return {
        type : SET_DIALOGS,
        payload : {
            dialogs
        }
    }
}

export const setCurrentDialogName = (name) => ({
    type : SET_CURRENT_NAME,
    payload : {
        name
    }
})

/**
 * Thunk
 * */

export const uploadSupportChat = () => {
    return (dispatch) => {
        dispatch({
            type : INIT_UPLOAD_DIALOGS_START,
        })
        RestService.customFetch(ajaxUrls.feedbackRequest)
            .then(res => {
                if (res.status >= 400) throw new Error(res.statusText)
                return res.json()
            })
            .then(({errcode, requests = []}) => {
                if (errcode === 200) {
                    dispatch({
                        type : INIT_UPLOAD_DIALOGS_SUCCESS,
                        payload : {
                            dialogs : requests.map(({name, created_at, updated_at, ...rest})=>({
                                ...rest,
                                name : name,
                                created_at : +created_at,
                                updated_at : +updated_at
                            })),
                        }
                    })
                } else {
                    throw new Error("Failed to download support dialogs")
                }
            })
            .catch(error => {
                console.warn(error) // TODO discuss with backend error handling
                dispatch({
                    type : INIT_UPLOAD_DIALOGS_FAIL,
                })
            })
    }
}

export const handleAskQuestion = (params) => {
    let {question} = params
    return (dispatch, getState) => {
        let name = currentDialogNameSelector(getState())

        let data = new FormData()
        data.append('Request', JSON.stringify({name, question}))
        RestService.bodyAsFormData(ajaxUrls.feedbackCreateRequest, data)
            .then(res => {
                if (res.status >= 400) throw new Error(res.statusText)
                return res.json()
            })
            .then(res => {
                let {errcode, requests : dialog, message = ""} = res
                if (errcode === 200) {
                    dispatch(setDialogs({dialogs : [dialog]}))
                } else {
                    if (message && typeof message === 'object') message = Object.values(message).join(" ")
                    throw new Error(message || 'Something went wrong')
                }
            })
            .catch(error => {
                console.warn(error) // TODO discuss with backend error handling
            })
    }
}


/*
* redux form
* */
export const handleCreateDialog = (params) => {
    let {name, question} = params
    return RestService.postFormData(ajaxUrls.feedbackCreateRequest, `Request=${JSON.stringify({name, question})}`)
            .then(res => {
                if (res.status >= 400) {
                    throw new SubmissionError({
                        _error : res.statusText,
                    })
                }
                return res.json()
            })
            .then(res => {
                let {errcode, requests : dialog, message = ""} = res
                if (errcode === 200) {
                    return {
                        ...dialog
                    }
                } else {
                    if (message && typeof message === 'object') message = Object.values(message).join(" ")
                    throw new SubmissionError({
                        _error : message || "Something went wrong",
                    })
                }
            })
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/modules/support.js